/**
 * Fires a success toast when the dashboard transitions from "onboarding" to "active".
 * Uses a ref to track the previous state so the toast fires exactly once per transition.
 * Does NOT fire on initial mount — prevState starts as undefined, not "onboarding".
 */

import { useRef, useEffect } from "react";
import { toast } from "sonner";

type DashboardState = "setup" | "onboarding" | "active";

export function useOnboardingCompleteToast(
  dashboardState: DashboardState,
  message: string,
) {
  const prevStateRef = useRef<DashboardState | undefined>(undefined);

  useEffect(() => {
    if (prevStateRef.current === "onboarding" && dashboardState === "active") {
      toast.success(message);
    }
    prevStateRef.current = dashboardState;
  }, [dashboardState, message]);
}
